import * as React from 'react';
import { IconChevronLeft12, IconChevronRight12 } from '@cian/ui-kit/icons';

import { TDirection } from '../ItemsCarousel/types';
import * as styles from './VerticalSmallArrow.css';

export interface IVerticalSmallArrowProps {
  direction: TDirection;
  offset?: number;
  onClick(): void;
}

const DEFAULT_OFFSET = -14;

export const VerticalSmallArrow: React.VFC<IVerticalSmallArrowProps> = ({
  direction,
  offset = DEFAULT_OFFSET,
  onClick,
}) => {
  const ArrowIcon = direction < 0 ? IconChevronLeft12 : IconChevronRight12;
  const style = direction < 0 ? { left: `${offset}px` } : { right: `${offset}px` };

  return (
    <div className={styles['arrow']} style={style} onClick={onClick}>
      <ArrowIcon color={'gray_icons_100'} />
    </div>
  );
};
